import React, { useEffect } from 'react';
import {Machine, MachineActiveTabs, Project} from '~/types';
import {useStoreActions, useStoreState} from '~/store';
import Dashboard from './Dashboard';
import Registration from './Registration';
import TabHeader from './TabHeader';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import { checkPermission } from '~/accessControl/helpers';
import { MachineTabs } from '~/app/data/statuses/machine';
import { route } from '~/app/helpers/route';
import { MACHINES_ROUTES } from '../Router';
import { getMachineSubTitle } from '../helpers';
import { useParams } from 'react-router';
import { useAppHeader } from '~/app/modules/appHeader';
import { ROUTES } from '~/app/Router';

export interface lastVisitedTab {
    lastVisitedTab: MachineActiveTabs['activeTab']
}

export type DetailsComponent = React.VFC;

const Details: DetailsComponent = () => {
    const permission = useStoreState(state => state.user.permissions);
    const machineDashboardPermission = checkPermission(permission, PERMISSION_GROUPS.machineDashboard);
    const machineRegistrationPermission = checkPermission(permission, PERMISSION_GROUPS.machineRegistration);
    const activeTab = useStoreState(state => state.machine.activeTab);
    const initActiveTab = useStoreActions(actions => actions.machine.initActiveTab);
    const machine = useStoreState(state => state.machine.data);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const {id, projectId} = useParams<{ id: Machine['id'], projectId: Project['id'] }>();

    const {setData} = useAppHeader();

    useEffect(() => {
        if (!activeTab || (activeTab !== MachineTabs.DASHBOARD && activeTab !== MachineTabs.REGISTRATION)) {
            initActiveTab();
        }
    }, [activeTab, initActiveTab]);

    const effectiveTab =
        activeTab === MachineTabs.DASHBOARD && machineDashboardPermission
            ? MachineTabs.DASHBOARD
            : activeTab === MachineTabs.REGISTRATION && machineRegistrationPermission
            ? MachineTabs.REGISTRATION
            : machineDashboardPermission
            ? MachineTabs.DASHBOARD
            : machineRegistrationPermission
            ? MachineTabs.REGISTRATION
            : activeTab;

    useEffect(() => {
        setData({
            backLink: +projectId ? route(MACHINES_ROUTES.machines, {projectId}) : route(ROUTES.projects),
            title: (machine.name || '').toUpperCase(),
            subTitle: getMachineSubTitle(machine),
            showUser: false,
            machineId: netWorkStatus === 0 ? id : '',
            machineImage: machine?.machineImage,
            projectId: '',
            parentFolderId: 0,
            showMachineMessages: effectiveTab === MachineTabs.REGISTRATION ? true : false,
            isIssueDetailPage: true,
            isServiceDetailPage: true,
            notification: true,
            search: false
        });
    }, [setData, id, machine, projectId, netWorkStatus, effectiveTab]);

    return (
        <>
            {machineDashboardPermission && machineRegistrationPermission && <TabHeader/>}
            {effectiveTab === MachineTabs.DASHBOARD && <Dashboard/>}
            {effectiveTab === MachineTabs.REGISTRATION && <Registration/>}
        </>
    );
};
export default Details
